import { BasicInfoStore } from './BasicInfoStore';
import { PortalStore } from './PortalStore';

let instance: RootStore;

export class RootStore {
    BasicInfoStore: BasicInfoStore;
    PortalStore: PortalStore;
    constructor() {
        if (instance == null) {
            instance = this;
        }
        this.BasicInfoStore = new BasicInfoStore(this);
        this.PortalStore = new PortalStore(this);
        // this.BasicInfoStore.initNativeStore();
        return instance;
    }
}

export default new RootStore();
